import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderClient } from 'src/app/entities/orderClient';
import { InitProvider } from 'src/app/services/init-provider';
import { PedidoService } from 'src/app/services/pedido-service';
import { SecurityService } from 'src/app/services/security-service';
import { UsuarioService } from 'src/app/services/usuario-service';

@Injectable({
  providedIn: 'root'
})
export class NewOrderService {

  constructor(
    private pedidoService: PedidoService,
    private usuarioService: UsuarioService,
    private initProvider: InitProvider,
    private securityService: SecurityService
  ) { }

  public automaticOrderSelection(): Observable<boolean> {
    return new Observable(observer => {
      // console.log(this.initProvider)
      if (this.initProvider.inicializaPedido) {
        //verifica se está logada
        if (this.securityService.hasToken()) {
          // verifica se não há pedido selecionado
          if (this.pedidoService.pedido == null) {
            // verifica o número de filiais
            let branches = this.initProvider.filiais;
            if (branches.length === 1) {   
              // verifica o numero de clientes
              this.usuarioService.getClientes({ busca: "%", id_usuario:this.initProvider.usuario.id }, async (clients) => {
                if (clients.length === 1) {
                  (await this.getTables(clients[0], branches[0]))
                    .subscribe((tables) => {
                      if (tables.length === 1) {
                        // verifica os tipos de pedido
                        this.usuarioService.getPedidoTipos((orderTypes) => {
                          if (orderTypes.length == 1) {
                            this.selectOrCreateOrder(clients[0], branches[0], tables[0], orderTypes[0])
                              .subscribe((res) => {
                                observer.next(res)
                              }, (error) => observer.next(false));
                          } else {
                            observer.next(false);
                          }
                        });
                      } else {
                        observer.next(false);
                      }
                    });
                } else {
                  observer.next(false);
                }
              });
            } else {
              observer.next(false);
            }
          } else {
            observer.next(false);
          }
        } else {
          observer.next(false);
        }
      } else {
        observer.next(false);
      }
    });
  }

  // private getTables(branch, client): Observable<any[]> {
  //   let id = 0
  //   console.log(client)

  //   new Observable(observer => {
  //   this.usuarioService.getClientes({busca:"%"}, (e) => {
  //     console.log(e[0].id)
  //     id = e[0].id
  //   })})
  //   return new Observable(observer => {
  //     // let branchTables = branch.tabelas.filter((f) => f.ativo);
  //     // let clientTables = client.tabelas.filter((f) => f.ativo);
  //     // if (branchTables.length) {
  //     //   observer.next(branchTables);
  //     // } else if (clientTables.length) {
  //     //   observer.next(clientTables);
  //     // } 
  //     // else {
  //       this.usuarioService.getTabelas(id, (userTables) => observer.next(userTables));
  //     // }
  //   });
  // }

  private async getTables(branch, client): Promise<Observable<any[]>> {
    console.log('a')
    try {
      let id = await this.getIdFromClientes();
      return new Observable(observer => {
        this.usuarioService.getClientesId({ id_cliente: id }, (userTables) => {
          observer.next(userTables.tabela_preco)
          // console.log(userTables[0].fn_cliente_id.content.tabela_preco[0])
        });
      });
    } catch (error) {
      // Lida com erros, se necessário
    }
  }
  
  private getIdFromClientes(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.usuarioService.getClientes({ busca: "%" }, (e) => {
        if (e && e[0] && e[0].id) {
          resolve(e[0].id);
        } else {
          reject(new Error("Erro ao obter o ID do cliente"));
        }
      });
    });
  }

  private selectOrCreateOrder(client, branch, table, orderType): Observable<boolean> {
    return new Observable(observer => {
      // verifica se existe pedido em digitação
      this.pedidoService.listaPedido({ page: 0 }, (orders) => {
        // caso exista, seleciona o primeiro
        if (orders.content.length === 1) {
          this.pedidoService.select(orders.content[0]);
          return observer.next(true);
        } else {
          return this.newOrder(client, branch, table, orderType, observer);
        }
      }, false);
    });
  }

  private newOrder(client, branch, table, orderType, observer): void {
    let pedidoClientes: OrderClient[] = [{
      idEnderecoErp: client.idEnderecoErp,
      cliente: client.id,
      quantidade: 0,
      subtotal: 0,
      impostos: 0,
      acrescimo: 0,
      acrescimoPercent: 0,
      desconto: 0,
      descontoPercent: 0,
      total: 0,
    }];

    let formPedido = {
      clientes: pedidoClientes,
      filial: branch.id,
      tabela: table.id,
      tipo: orderType.id,
      dataEntrega: ""
    };
    this.pedidoService.abrir(
      formPedido,
      (resp) => {
        this.pedidoService.select(resp)
        observer.next(true);
      },
      (error) => {
        console.error(error);
        observer.next(false);
      });
  }
}